module.exports = __webpack_public_path__ + "static/vanessa_coote-8c3d4fda8ce4451377d6d5a9ff8e0abe.jpg";